/**
 * @file 四川天府
 * @author zhuqijia
 */
import Vue from 'vue';
import Router from 'vue-router';
import '@/common/style/index.scss';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'main',
            component: () => import('./views/Main/Main.vue'),
            meta: {
                pageTitle: '百度地图打车权益'
            }
        }
    ]
});
